<section class="page-container">
  <div class="flex items-center justify-between">
    <h1 class="main-heading">Account Code Creation</h1>
    <app-navpath />
  </div>
  <div class="content-container">
    <app-data-form
      [dataFields]="form"
      (updateFields_child)="updateFields($event)"
      (clickSearch)="fetchDetails($event)"
    />
    <div class="mt-4 flex w-fit gap-1">
      <button
        class="shorter-btn add-btn"
        (click)="add()"
        [disabled]="lockUpdate"
      >
        <fa-icon [icon]="faSave" class="mr-1" />Add New
      </button>
      <button
        class="shorter-btn delete-btn"
        [disabled]="lockUpdate"
        (click)="delete()"
      >
        <fa-icon [icon]="faBroom" class="mr-1" />Delete
      </button>
      <button class="shorter-btn clear-btn" (click)="clear()">
        <fa-icon [icon]="faBroom" class="mr-1" />Clear
      </button>
    </div>
  </div>
</section>
